<template>
  <div id="goTop"
       class="listMore"
       v-show="goTopShow">
    <i class="more_ico"
       @click="goTop"></i>
  </div>
</template>
<script>
export default {
  name: 'goTop',
  data() {
    return {
      scrollTop: '',
      goTopShow: true,
    }
  },
  watch: {
    scrollTop(val) {
      if (this.scrollTop > 500) {
        // this.goTopShow = true
      } else {
        // this.goTopShow = false
      }
    },
  },
  methods: {
    handleScroll() {
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      if (this.scrollTop > 500) {
        this.goTopShow = true
      }
    },
    goTop() {
      let timer = null,
        _that = this
      cancelAnimationFrame(timer)
      timer = requestAnimationFrame(function fn() {
        if (_that.scrollTop > 0) {
          _that.scrollTop -= 150
          document.body.scrollTop = document.documentElement.scrollTop =
            _that.scrollTop
          timer = requestAnimationFrame(fn)
        } else {
          cancelAnimationFrame(timer)
          // _that.goTopShow = false;
        }
      })
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
}
</script>






// WEBPACK FOOTER //
// src/components/goTop.vue